import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import React from 'react';
import { useIsDesktop, useIsTablet } from '../../utils/mediaQueries';
import { GoalProgressNotificationWidget } from '../GoalProgressNotificationWidget/GoalProgressNotificationWidget';
import { SalesNotificationWidget } from '../SalesNotificationWidget/SalesNotificationWidget';
import styles from './styles';
export const CardContent = ({ data }) => {
    const { actualSales, targetSales, repeatPeriod, daysLeft, targetCustomers, actualCustomers } = data || {};
    const isDesktop = useIsDesktop();
    const isTablet = useIsTablet();
    const isTabletOrMobile = isTablet || !isDesktop;
    let widgetType = '';
    if ((actualSales && targetSales) || (actualCustomers && targetCustomers)) {
        widgetType = 'progress';
    }
    const widget = {
        progress: (_jsx(Box, { marginY: 1.5, sx: isDesktop ? styles.grayContainerWithBorder({ isTabletOrMobile }) : {}, children: _jsx(GoalProgressNotificationWidget, { actual: actualSales || actualCustomers, target: targetSales || targetCustomers, repeat: repeatPeriod, daysleft: daysLeft }) })),
        sales: (_jsx(Box, { marginY: 1.5, sx: styles.grayContainerWithBorder({ isTabletOrMobile }), children: _jsx(SalesNotificationWidget, {}) })),
    };
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return widgetType ? widget[widgetType] : _jsx(Box, {});
};
